import axios from 'axios'
import { getAuthorizedConfiguration } from '../helpers/RequestHelper'

/// Bolean type
export const IS_SAVING_IMAGE_CONTAINER = 'IS_SAVING_IMAGE_CONTAINER'
export const IS_DELETING_SPARE_PART_IMAGE = 'IS_DELETING_SPARE_PART_IMAGE'
export const IS_UPLOADING_SPARE_PART_IMAGE = 'IS_UPLOADING_SPARE_PART_IMAGE'
export const IS_GETING_IMAGE_CONTAINER = 'IS_GETING_IMAGE_CONTAINER'

//Object type
export const SET_SPARE_PART_IMAGE = 'SET_SPARE_PART_IMAGE'
export const SET_IMAGES_BY_CODE_SEACH = 'SET_IMAGES_BY_CODE_SEACH'

/**
 * Function to is saving request Image Container
 * @param {*} status
 */
export const setSparePartImage = (data) => {
	return {
		type: SET_SPARE_PART_IMAGE,
		data
	}
}

/**
 * Function to is saving request Image Container
 * @param {*} status
 */
export const setImgesByCodeSearch = (data) => {
	return {
		type: SET_IMAGES_BY_CODE_SEACH,
		data
	}
}

/**
 * Function to is saving request Image Container
 * @param {*} status
 */
export const isSavingImageContainer = (status) => {
	return {
		type: IS_SAVING_IMAGE_CONTAINER,
		status
	}
}

/**
 * Function to is deleting request uploadImage
 * @param {*} status
 */
export const isDeletingSparePartImage = (status) => {
	return {
		type: IS_DELETING_SPARE_PART_IMAGE,
		status
	}
}

/**
 * Function to is geting Image Container
 * @param {*} status
 */
export const isGetingImageContainer = (status) => {
	return {
		type: IS_GETING_IMAGE_CONTAINER,
		status
	}
}

/**
 * Function to is uploading request uploadImage
 * @param {*} status
 */
export const isUploadingSparePartImage = (status) => {
	return {
		type: IS_UPLOADING_SPARE_PART_IMAGE,
		status
	}
}

/**
 * Action create image container for Sap serial
 */
export const addImageContainer = (equipment, material) => {
	return async (dispatch, getState) => {
		try {
			dispatch(isSavingImageContainer(true))
			// Get the authorized configuration
			let user = getState().oidc.user
			let config = getAuthorizedConfiguration(user)
			// Create command
			let command = {
				Code: material?.Code ? material?.Code : '',
				Description: material?.Description ? material?.Description : '',
				Serie: equipment?.Serie ? equipment?.Serie : '',
				Model: equipment?.Model ? equipment?.Model : '',
				MaterialCode: equipment?.MaterialCode ? equipment?.MaterialCode : '',
				MaterialDescription: equipment?.DescriptionMaterial ? equipment?.DescriptionMaterial : '',
				CustomerCode: equipment?.CustomerCode ? equipment?.CustomerCode : '',
				CustomerName: equipment?.CustomerName ? equipment?.CustomerName : '',
				DestinationCode: equipment?.DestinatarionCode ? equipment?.DestinatarionCode : '',
				DestinationName: equipment?.DestinatarionName ? equipment?.DestinatarionName : ''
			}
			let url = `${window.config.serviceManagementBackendUrl}/SparePartImages`

			let serverResponse = await axios.post(url, command, config)
			dispatch(setSparePartImage(serverResponse.data))
			dispatch(isSavingImageContainer(false))
		} catch (err) {
			dispatch(isSavingImageContainer(false))
			if (err.response) {
				return Promise.reject(err.response.data)
			} else {
				return Promise.reject({ Message: 'addImageContainer: Unexpected error thrown' })
			}
		}
	}
}

/**Delete Spare Part Image */
export const deleteSparePartImage = (code, imageNames) => {
	return function(dispatch, getState) {
		dispatch(isDeletingSparePartImage(true))
		let user = getState().oidc.user
		let config = getAuthorizedConfiguration(user)
		let url = `${window.config.serviceManagementBackendUrl}/SparePartImages/deleteImage/${imageNames}/${code}`
		return axios
			.delete(url, {...config, data: imageNames})
			.then((serverResponse) => {
				dispatch(isDeletingSparePartImage(false))
				dispatch(setImgesByCodeSearch(serverResponse.data))
				return Promise.resolve(serverResponse.data)
			})
			.catch((error) => {
				dispatch(isDeletingSparePartImage(false))
				console.error('Error to remove image', error)
				return Promise.reject(error.response.data.Message)
			})
	}
}

/**
 * Action get images
 */
export const getSparePartImage = (code) => {
	return async (dispatch, getState) => {
		try {
			dispatch(isGetingImageContainer(true))
			// Get the authorized configuration
			let user = getState().oidc.user
			let config = getAuthorizedConfiguration(user)
			let url = `${window.config.serviceManagementBackendUrl}/SparePartImages/${code}`

			let serverResponse = await axios.get(url, config)

			dispatch(setSparePartImage(serverResponse.data))
			dispatch(isGetingImageContainer(false))
		} catch (err) {
			dispatch(isGetingImageContainer(false))
			if (err.response) {
				return Promise.reject(err.response.data)
			} else {
				return Promise.reject({ Message: 'getSparePartImage: Unexpected error thrown' })
			}
		}
	}
}

/**
 * Action get all images
 */
export const getAllSparePartImage = (code) => {
	return async (dispatch, getState) => {
		try {
			dispatch(isGetingImageContainer(true))
			dispatch(setImgesByCodeSearch([]))

			// Get the authorized configuration
			let user = getState().oidc.user
			let config = getAuthorizedConfiguration(user)
			let url = `${window.config.serviceManagementBackendUrl}/SparePartImages/search/${code}`

			let serverResponse = await axios.get(url, config)

			dispatch(setImgesByCodeSearch(serverResponse.data))
			dispatch(isGetingImageContainer(false))
		} catch (err) {
			dispatch(isGetingImageContainer(false))
			if (err.response) {
				return Promise.reject(err.response.data)
			} else {
				return Promise.reject({ Message: 'getAllSparePartImage: Unexpected error thrown' })
			}
		}
	}
}

/**
 * Action save images
 */
export const saveSparePartImage = (files) => {
	return async (dispatch, getState) => {
		try {
			dispatch(isUploadingSparePartImage(true))
			// Get the authorized configuration
			let user = getState().oidc.user
			let config = getAuthorizedConfiguration(user)

			// Create command
			let command = {}

			///Add files
			let data = new FormData()
			for (var index = 0; index <= files.length; index++) {
				data.append('file', files[index])
			}
			data.append('command', JSON.stringify(command))

			let url = `${window.config.serviceManagementBackendUrl}/SparePartImages/uploadImage`

			await axios.post(url, data, config)
			dispatch(isUploadingSparePartImage(false))
		} catch (err) {
			dispatch(isUploadingSparePartImage(false))
			if (err.response) {
				return Promise.reject(err.response.data)
			} else {
				return Promise.reject({ Message: 'saveSparePartImage: Unexpected error thrown' })
			}
		}
	}
}

export const downloadSparePartImagesReport = () => {
	return function(dispatch, getState) {
		dispatch(isUploadingSparePartImage(true))

		let user = getState().oidc.user
		let config = getAuthorizedConfiguration(user)
		let endPoint = `${window.config.serviceManagementBackendUrl}/SparePartImages/generateReport`
		return axios
			.get(endPoint, {
				responseType: 'arraybuffer',
				...config // esto expande correctamente los headers
			})
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(isUploadingSparePartImage(false))

					var blob = new Blob([serverResponse.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					})
					let url = window.URL.createObjectURL(blob)
					let a = document.createElement('a')
					a.href = url
					a.download = `spare_parts_images_list.xlsx`
					a.click()
					return Promise.resolve('Ok')
				}
			})
			.catch((error) => {
				dispatch(isUploadingSparePartImage(false))
				console.error('Error donwload list of customers users', error)
				return Promise.reject()
			})
	}
}
